// @ts-nocheck
import React, { useMemo } from 'react';
import { navigate } from '../../lib/routerAdapter';
import { crewApi } from '../../lib/api';
import CommonListPage from '../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from '../withUserAccess';
import { accessTypeEnum } from '../../lib/enum';
const entryPointPath = '/admin/crew/';
const access = {
  add: () => navigate(`${entryPointPath}new`)
};
export default withUserAccess(({
  userAccess
}) => {
  const columns = useMemo(() => [{
    title: '№',
    dataIndex: 'id'
  }, {
    title: 'Наименование',
    dataIndex: 'name'
  }], []);
  const canAdd = () => userAccess.some(access => [accessTypeEnum.admin, accessTypeEnum.handlingCrew].includes(access));
  return <Page>
      <CommonListPage crud={crewApi} pageHeaderProps={{
      mainHeader: 'Бригады',
      access: canAdd() ? access : undefined
    }} tableListProps={{
      columns,
      onSelect: id => canAdd() && navigate(`${entryPointPath}${id}`),
      canDelete: canAdd()
    }} />
    </Page>;
});
